module.exports = __webpack_public_path__ + "img/icon_map_61_off_001.f3c7aadf.png";